import { request } from "../api";

export interface DashboardSummary {
  users: {
    total: number;
    active: number;
    members: number;
    admins: number;
  };
  devices: {
    total: number;
    active: number;
    online?: number;
    stale: number;
  };
  policies: {
    compiled_total: number;
    network_compiled_total?: number;
    network_acked_total?: number;
    enforcement_pct?: number;
  };
  network?: {
    domain_requests_24h: number;
    policy_denials_24h: number;
    allowed_requests_24h: number;
    logged_requests_24h: number;
    new_domains_24h: number;
    open_access_requests: number;
  };
  audit: {
    latest: {
      id: number;
      action: string;
      actor_type: string;
      target_type: string;
      created_at: string;
    }[];
  };
}

export const dashboardApi = {
  summary: () => request<DashboardSummary>("/api/admin/v1/dashboard/summary/"),
};
